import { render, staticRenderFns } from "./tn-section.vue?vue&type=template&id=00745047&"
import script from "./tn-section.vue?vue&type=script&lang=js&"
export * from "./tn-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports